<template>
    <section>
      <section class="grid-flex column">
        <!-- filters -->
        <div class="flex-1 w100">
          <div class="flex">
            <tabs :data="configTabs" v-model="currentTab" type="default-scroll"></tabs>
          </div>
        </div>
      </section>
      <section class="margin-top-m">
        <!-- account -->
        <account v-if="currentTab === 'account'"></account>
        <!-- profile -->
        <profile v-if="currentTab === 'profile'"></profile>
        <!-- onboarding -->
        <onboarding v-if="currentTab === 'onboarding'"></onboarding>
        <!-- integration -->
        <integration v-if="currentTab === 'integracoes'"></integration>
        <!-- imports -->
        <imports v-if="currentTab === 'imports'"></imports>
        <!--exportar -->
        <export v-if="currentTab === 'exports'"></export>
        <!-- users -->
        <user v-if="currentTab === 'user'"></user>
        <!-- project -->
        <project v-if="currentTab === 'project'"></project>
      </section>
    </section>
  </template>
  
  <script>
  import Tabs from "@/components/tabs/Tabs";
  import { mapState } from "vuex";

  import integration from "./Integration";
  import Account from "./Account";
  import Profile from "./Profile";
  import User from "./User";
  import Project from "./Project";
  import Imports from "./Imports";
  import Onboarding from "./Onboarding";
  import Export from "@/modules/export/Export";
  
  export default {
    name: "config",
    components: {
      Tabs,
      Account,
      Profile,
      User,
      integration,
      Project,
      Imports,
      Export,
      Onboarding
    },
    props: ['slug'],
    data() {
      return {
        loading: false,
        currentTab: "account",
      };
    },
    mounted() {
      if (this.slug) {
        this.currentTab = this.slug
      }
    },
    computed: {
      ...mapState({
        user: (state) => state.user,
        account: (state) => state.account,
      }),
      configTabs() {
      if (this.account.account_type === 'MANAGER') {
        return [
          {
            name: "profile",
            title: "Perfil",
          },
          {
            name: "account",
            title: "Conta",
          },
          {
            name: "integracoes",
            title: "Integrações",
          },
          {
            name: "onboarding",
            title: "Onboarding",
          },
          {
            name: "imports",
            title: "Importações",
          },
          {
            name: "exports",
            title: "Exportar",
          },
          {
            name: "user",
            title: "Equipe (Usuários)",
          },
          {
            name: "project",
            title: "Projetos (Clientes)",
          },
        ]
      } else {
        return [
          {
            name: "profile",
            title: "Perfil",
          },
          {
            name: "account",
            title: "Conta",
          },
          {
            name: "integracoes",
            title: "Integrações",
          },
          {
            name: "onboarding",
            title: "Onboarding",
          },
          {
            name: "imports",
            title: "Importações",
          },
          {
            name: "user",
            title: "Equipe (Usuários)",
          },
        ]
      }
      },
    },
    watch: {
      slug() {
        if (this.slug) {
          this.currentTab = this.slug
        } 
      },
      currentTab() {
        if (this.slug === this.currentTab) {
          return
        }
        this.$router.push({ name: "Config", params: { slug: this.currentTab } });
      }
    }
  
  };
  </script>
  
  <style lang="scss" scoped></style>
  